import {App} from 'vue'
import '../styles/floating-vue-style.scss'
import {i18n} from '../setup/i18n'
import {createHead} from '@unhead/vue'

export function setupVuePlugins(vueApp: App): void {
  const head = createHead()
  vueApp.use(head)
  vueApp.use(i18n)
}
